export default function fetchReportBuilderData() {
  const url = "/api/sitecore/ReportBuilder/GetUserReportState";

  return fetch(url, {
    method: "GET", // *GET, POST, PUT, DELETE, etc.
    mode: "cors", // no-cors, *cors, same-origin
    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
    credentials: "same-origin", // include, *same-origin, omit
    headers: {
      "Content-Type": "application/json",
      // 'Content-Type': 'application/x-www-form-urlencoded',
    },
    redirect: "follow", // manual, *follow, error
    referrerPolicy: "no-referrer", // no-referrer, *client
  })
    .then((r) => r.json())
    .then((data) => data.DraftReport)
    .catch((e) => []); // fallback to an empty array in the case of a network error;
}
